import Axios from "axios";
import sessionExpired from "../Core/sessionExpired";
import { decrypt } from "../utils/others";
// import { BASE_URL } from "./../Core/constants";

const BASE_URL = process.env.REACT_APP_EPICENTERAPI_BASE_URL;

// Read the CURRENT session per request — never cache tokens at module load.
// The old module-scope snapshot froze whatever localStorage held when the
// bundle first executed, so a re-login (e.g. via the sessionExpired dialog in
// another tab) kept sending the OLD tokens until a full reload — surfacing as
// "Session Expired" popups right after logging back in.
const getSessionTokens = () => {
  try {
    const user = decrypt(localStorage.getItem("user"));
    return {
      accessToken: (user && user.ACCESS_TOKEN) || "",
      refreshToken: (user && user.REFRESH_TOKEN) || "",
    };
  } catch {
    return { accessToken: "", refreshToken: "" };
  }
};

const api = function (baseUrl) {
  this.apiBase = baseUrl;
  this.axios = Axios.create({
    baseURL: this.apiBase,
    timeout: 100000000,
    //#region [comment]
    // onUploadProgress ( p ) {
    //     const progress = p.loaded / p.total;

    //     // check if we already displayed a toast
    //     if ( toastId === null ) {
    //         toastId = toast( 'Upload in Progress', {
    //             progress: progress
    //         } );
    //     } else {
    //         toast.update( toastId, {
    //             progress: progress
    //         } );
    //     }
    // },
    // onDownloadProgress ( p ) {
    //     const progress = p.loaded / p.total;

    //     // check if we already displayed a toast
    //     if ( toastId === null ) {
    //         toastId = toast( 'Download in Progress', {
    //             progress: progress
    //         } );
    //     } else {
    //         toast.update( toastId, {
    //             progress: progress
    //         } );
    //     }
    // }
    //#endregion
  });
  this.axios.defaults.headers.post["Content-Type"] = "application/json";
  this.axios.interceptors.request.use(
    (req) => {
      const { accessToken, refreshToken } = getSessionTokens();
      req["headers"]["Authorization"] = `Bearer ${accessToken}`;
      req["headers"]["refresh-token"] = refreshToken;
      return req;
    },
    (e) => {
      return Promise.reject(e);
    },
  );
  this.axios.interceptors.response.use(
    (res) => {
      return res;
    },
    (e) => {
      if (
        e.response &&
        e.response.status === 401 &&
        e.response.data.msg === "Invalid Authorization"
      ) {
        sessionExpired();
      }
      return Promise.reject(e);
    },
  );
};

api.prototype.getApiBase = function () {
  return this.apiBase;
};

api.prototype.get = function (url, params = {}, data = {}, config = {}) {
  return this.axios({
    method: "get",
    url,
    params,
    data,
    ...config,
  });
};

api.prototype.post = function (url, data = {}, params = {}, config = {}) {
  return this.axios({
    method: "post",
    url,
    data,
    params,
    ...config,
  });
};

api.prototype.put = function (url, data, params = {}, config = {}) {
  return this.axios({
    method: "put",
    url,
    data,
    params,
    ...config,
  });
};

api.prototype.patch = function (url, data = {}, params = {}, config = {}) {
  return this.axios({
    method: "patch",
    url,
    data,
    params,
    ...config,
  });
};

api.prototype.delete = function (url, data, params, config = {}) {
  return this.axios({
    method: "delete",
    url,
    data,
    params,
    ...config,
  });
};

const API = new api(BASE_URL);

export { API };
